module.exports = __webpack_public_path__ + "static/media/flight-seagul-right.a54b8af7.gif";